function Footer(){
    return(
        <div className="footercontainer">
            <footer>
                <a className="footer-left" href="https://www.linkedin.com/in/vishal-thakur-437136257/">Designer: Vishal</a>
                <div className="footer-right">
                    <a href="https://www.linkedin.com/in/abhay-banyal-906283229/">Developer: Abhay </a>
                    <a className="footer-right" href="https://www.linkedin.com/in/sagar-sharma-43b74a219/"> and Sagar</a>
                </div>
            </footer>
        </div>
    );
}

export default Footer;